class UspSlider extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll('[data-usp-slide]');
    this.mediaSlides = this.querySelectorAll('[data-usp-media]');
    this.dots = this.querySelectorAll('[data-usp-dot]');
    this.card = this.querySelector('.section-usps__card');
    this.currentSlide = 0;
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) * 1000;
    this.slideInterval = null;
    this.dragStartX = 0;
    this.dragStartY = 0;
    this.isDragging = false;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.stopAutoplay();
        this.goToSlide(index);
      });
    });

    this.handlePointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-usp-dot]')) return;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.isDragging = true;
      this.setPointerCapture(event.pointerId);
      this.classList.add('is-dragging');
    };

    this.handlePointerUp = (event) => {
      if (!this.isDragging) return;
      this.isDragging = false;
      if (this.hasPointerCapture(event.pointerId)) {
        this.releasePointerCapture(event.pointerId);
      }
      this.classList.remove('is-dragging');

      const deltaX = event.clientX - this.dragStartX;
      const deltaY = event.clientY - this.dragStartY;
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      this.stopAutoplay();
      if (deltaX < 0) {
        this.goToSlide((this.currentSlide + 1) % this.slides.length);
      } else {
        this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length);
      }
    };

    this.addEventListener('pointerdown', this.handlePointerDown);
    this.addEventListener('pointerup', this.handlePointerUp);

    if (this.autoplaySpeed > 0) {
      this.startAutoplay();
    }
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });
    this.mediaSlides.forEach((mediaSlide, mediaIndex) => {
      mediaSlide.classList.toggle('is-active', mediaIndex === index);
    });
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
    });
    this.card.style.setProperty('--usp-highlight-color', this.slides[index].dataset.highlightColor);
  }

  startAutoplay() {
    this.slideInterval = setInterval(() => {
      this.goToSlide((this.currentSlide + 1) % this.slides.length);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
      this.slideInterval = null;
    }
  }
}

if (!customElements.get('usp-slider')) {
  customElements.define('usp-slider', UspSlider);
}
